import axios from "axios";
import { ADD_EXPERCISE, ALL_NOTIFICATION_USER, BLOCK_USER_LIST, CHANGE_PASSWORD, DASHBOARD, DELETE_EXPERCISE, DELETE_POST, EDIT_EXPERCISE, EXPERCISE_LIST, GET_POST_ALL, GET_USER_POST, LOGIN_API, LOGOUT_API, REPORT_DETAILS, REPORT_LIST, SEND_NOTIFICATION, USER_BLOCK_UNBLOCK, USER_DELETE, USER_DETAILS, USER_LIST } from "./Api";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const header = {
  "Content-type": "application/json",
};

export const loginApi = (data) => {
  return axios.post(LOGIN_API, data, {
    headers: header,
  });
};

export const changePassword = (data) => {
  return axios.put(CHANGE_PASSWORD, data, {
    headers: header,
  });
};

export const getdashboardCount = () => {
  return axios.get(DASHBOARD);
};

export const getAlluser = (data) => {
  return axios.get(USER_LIST, {
    params: data,
  });
};

export const getBlockAlluser = (data) => {
  return axios.get(BLOCK_USER_LIST, {
    params: data,
  });
};


export const userDetails = (id) => {
  return axios.get(`${USER_DETAILS}?user_id=${id}`);
};

export const userPost = (data) => {
  return axios.get(GET_USER_POST, {
    params: data,
  });
};

export const blockUnblockUser = (data) => {
  return axios.patch(USER_BLOCK_UNBLOCK, data, {
    headers: header,
  });
};

export const deleteUsers = (data) => {
  return axios.delete(USER_DELETE, {
    data: data,
    headers: header,
  });
};

export const getUserpost = (data) => {
  return axios.get(GET_USER_POST, {
    params: data,
  });
};

export const getAllpost = (data) => {
  return axios.get(GET_POST_ALL, {
    params: data,
  });
};

export const deletepost = (data) => {
  return axios.delete(DELETE_POST, {
    data: data,
    headers: header,
  });
};

export const allExcerciseList = (data) => {
  return axios.get(EXPERCISE_LIST, {
    params: data,
  });
};


export const addExcercise = (data) => {
  return axios.post(ADD_EXPERCISE, data, { headers: header });
};


export const editExcercise = (data) => {
  return axios.patch(EDIT_EXPERCISE, data, {
    headers: header,
  });
};

export const deleteExcercise = (data) => {
  return axios.delete(DELETE_EXPERCISE, {
    data: data,
    headers: header,
  });
};

export const getNotificationUsers = (data) => {
  return axios.get(ALL_NOTIFICATION_USER, {
    headers: header,
  });
};

export const sendNotification = (data) => {
  return axios.post(SEND_NOTIFICATION, data, {
    headers: header,
  });
};

export const logoutApi = () => {
  return axios.post(LOGOUT_API);
};

export const getRepostsList = (data) => {
  return axios.get(REPORT_LIST, {
    params: data,
  });
};

export const getRepostsListDetails = (data) => {
  return axios.get(REPORT_DETAILS, {
    params: data,
  });
};

